import { withStyles } from '@material-ui/core';

import RowCellsContent from './component';
import styles from './styles';

export default withStyles(styles)(RowCellsContent);
